import styled from 'styled-components';

import { Button, Card } from '../../designComponents';
import {
  flexCenter,
  flexSpaceBetween,
  flexStart,
  multipleLineTextEllipse,
} from '../../style/reusableStyle';

export const DashboardContainer = styled.div`
  padding-bottom: 50px;
  background-color: ${({ theme }) => theme.colors.lighterBackground};
`;

export const CounterCardContainer = styled.div`
  ${flexStart};
  gap: 20px;
  flex-wrap: wrap;
  padding-top: 40px;
  margin-bottom: 20px;

  & .counter-card {
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    ${flexCenter(0)}
    & .counter-card {
      width: 190px;
    }
  }
`;

export const GraphJobsAndPrposalWrapper = styled.div`
  ${flexStart};
  flex-direction: column;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    flex-direction: row;
    align-items: flex-start;
    gap: 20px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    ${flexStart};
    flex-direction: column;
    gap: 20px;
  }
`;

export const GraphContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: repeat(auto-fit, minmax(330px, 1fr));
  }
`;

export const JobsAndProposalWrapper = styled.div`
  ${flexSpaceBetween(20)};
  align-items: flex-start;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    flex-wrap: wrap;
  }
`;

export const JobsContainer = styled(Card)`
  padding: 30px 20px;
  flex: 1;
  min-width: 300px;
  & .individual-job {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 200px;

    .notes {
      ${multipleLineTextEllipse(2)}
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
      min-width: 600px;
    }
  }
`;
export const ProposalContainer = styled(Card)`
  padding: 30px 20px;
  min-width: 300px;
  flex: 1;

  & .individual-proposal {
    width: 100%;
    display: flex;
    gap: 12px;
    & .proposal-info {
      flex: 1;
      b {
        font-weight: 600;
      }
      & .actions-wrapper {
        padding: 0px 20px;
        width: 100%;
        ${flexSpaceBetween(20)};
        margin-top: 12px;
      }
    }
  }
`;

export const StyledButton = styled(Button)`
  padding: 0px 0px;
  height: auto;
  color: ${({ theme }) => theme.colors.border};
  background-color: inherit;
  border: none;
  font-size: 12px;

  &.view-all {
    margin-top: 30px;
  }
`;

// --------------Technician Styles-----------------------------------

export const CardsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;

  @media (max-width: 720px) {
    flex-wrap: wrap;
  }
`;

export const LineGraphAndPdfWrapper = styled.div`
  flex: 1.3;
  min-width: 330px;
  max-width: 700px;

  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 20px;
`;

export const CompletedPDFWrapper = styled(Card)`
  padding: 40px 30px;
  & .pdf-title {
    margin-bottom: 16px;
  }
  & .pdfs-container {
    & .individual-pdf {
      & .job-title {
        margin-bottom: 8px;
      }
      & .row {
        ${flexStart};
        gap: 10px;
        margin-bottom: 6px;
        & .title {
          flex: 0 0 auto;
        }
        & .value {
          ${flexStart};
          gap: 8px;
          flex-wrap: wrap;
        }
      }
    }
  }
`;

export const JobListingAndScheduleWrapper = styled.div`
  flex: 1;
  min-width: 340px;
  max-width: 500px;

  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 20px;
`;

export const JobListingWrapper = styled(Card)`
  padding: 28px 24px;

  & .job-listing-heading {
    margin-bottom: 16px;
  }

  & .jobs-container {
    position: relative;
    cursor: pointer;
    & .individual-job {
      display: flex;
      width: 100%;
      gap: 10px;
      & .job-details {
        flex: 1;

        & .row {
          display: flex;
          gap: 8px;

          & .label {
            flex: 0 0 auto;
          }
          & .value {
          }
        }
      }

      & .job-date-and-status {
        display: flex;
        gap: 20px;
        justify-content: flex-end;
        align-items: center;
        & .date {
          margin-bottom: 6px;
        }
      }

      @media (max-width: ${({ theme }) => theme.breakpoints.xl}) {
        flex-direction: column;
      }
    }
  }

  & .view-all-wrapper {
    ${flexCenter(0)};
    margin-top: 30px;
  }
`;

export const ScheduleWrapper = styled(Card)`
  padding: 20px 28px;
  & .heading-wrapper {
    ${flexSpaceBetween(0)};
    margin-bottom: 18px;

    & .custom-select-container {
      width: 110px;
      & .custom-select {
        padding: 4px 10px;
      }
      & .custom-option {
        padding: 7px 10px;
      }
    }
  }
  & .schedule-container {
    & .individual-schedule {
      margin-bottom: 20px;
    }
  }
`;

// --------------Printer Styles-----------------------------------

export const ClientInfoJobMessageWrapperStyled = styled.div`
  max-width: 930px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    align-items: flex-start;

    & .data-row {
      padding: 18px 6px;
      width: 100%;
    }
  }
  @media (max-width: 700px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const ClientAndJobsWrapperStyled = styled.div`
  flex: 1;
  ${flexSpaceBetween(0)};
  flex-direction: column;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100%;
  }
`;

export const ClientInfoStyled = styled(Card)`
  max-width: 100%;
  background-color: ${({ theme }) => theme.colors.white};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100%;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 100%;
    & .individual-message {
    }
  }
`;
export const JobsStyled = styled(Card)`
  background-color: ${({ theme }) => theme.colors.white};
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100%;
  }
`;
export const MessageBoxStyled = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  min-width: 348px;
  border-radius: 10px;
  padding: 30px 26px;
  gap: 12px;

  & .card-list {
    padding-top: 20px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    min-width: 260px;
    padding: 20px 12px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 100%;
    padding: 20px 12px;
  }

  & .individual-message {
    display: flex;
    gap: 32px;
    & .left-part {
      position: relative;
      height: ${({ theme }) => theme.sizes._5xl};

      & .activity-status-color {
        position: absolute;
        bottom: 0px;
        right: 0px;
        width: 11px;
        height: 11px;
        border-radius: 50%;
      }
    }
    & .right-part {
      position: relative;
      width: calc(100% - 50px);
      height: ${({ theme }) => theme.sizes._7xl};

      & .message-status-color {
        position: absolute;
        top: 0px;
        right: 10px;
        width: 14px;
        height: 14px;
        border-radius: 50%;
      }
      & .sent-msg {
        background-color: red;
        width: 140px;
        height: 140px;
        border-radius: 50%;
      }

      & .status-icon {
        width: 14px;
        height: 14px;
        border: 1px solid ${({ theme }) => theme.colors.secondary};
        padding: 1px;
      }
    }
  }
`;
export const ClinetAndJob = styled.div`
  .client {
    display: flex;
    flex-direction: column-reverse;
  }
`;

export const ClientInformation = styled.div`
  max-width: 600px;
`;
